// extracted by mini-css-extract-plugin
module.exports = {"hierarchy-collapse-btn":"VIP_CollapseHierarchy__hierarchy-collapse-btn","hierarchyCollapseBtn":"VIP_CollapseHierarchy__hierarchy-collapse-btn"};